import {gsap} from "gsap";

import TemplateContents from './TemplateContents';
import TopBG from './TopBG';
import TopMask1 from './TopMask1';
import TopMask2 from './TopMask2';
import TopMask3 from './TopMask3';
import TopMask4 from './TopMask4';
import * as THREE from "three";


export default class extends TemplateContents{
    constructor(param){
        super(param);
    }

    init() {
        super.init(true);

        //最初はbgのみnewするそれ以外のWebGLオブジェクトはset関数で実行
        this.bg = new TopBG();

        this.initEvents();
        this.initSections();

        this.pack.common.addScrollTarget(this);
        this.pack.common.addEnterframeTarget(this);
    }

    set(){
        //読み込み完了したら時間差設定
        this.bg.set();
        this.mask1 = new TopMask1();
        this.mask2 = new TopMask2();
        if(this.pack.mask3) {
            this.mask3 = this.pack.mask3;
            this.mask3.reset(true);
        }else {
            this.mask3 = this.pack.mask3 = new TopMask3(true);
            this.mask3.setCanvasDOM(true);
        }
        this.mask4 = new TopMask4();
        this.floatRocksAnimation();
    }

    reset(){
        super.reset();

        this.setVars();
        this.pack.common.addScrollTarget(this);
        this.pack.common.addEnterframeTarget(this);

        this.initSections();

        this.bg.reset();
        this.mask1.reset();
        this.mask2.reset();
        this.mask3.reset(true);
        this.mask4.reset();
        this.floatRocksAnimation();
    }

    destruct(){
        super.destruct();

        // this.pack.header.changeColor(false);

        document.removeEventListener('mousemove', this.bindPointerMoveHandler);

        this.pack.common.removeScrollTarget(this);
        this.pack.common.removeEnterframeTarget(this);
    }

    destructAfterContentsOut(){
        this.bg.destructAfterContentsOut();
        this.mask1.destructAfterContentsOut();
        this.mask2.destructAfterContentsOut();
        this.mask3.destructAfterContentsOut();
        this.mask4.destructAfterContentsOut();
    }

    setVars(){
        super.setVars();

        this.transitionTween;
        this.sectionHero12ScrollableHeight;
        this.sectionHero12ScrollableSingleHeight;

        this.enabled = false;
        this.enabledScroll = false;
        this.currentSection = 0;        //0->hero, 1->section1, 2->section2, 3->section3, 4->section4
        this.transitionDuration = 1.0;
        this.transitionEase = 'quint.inOut';

        this.isInTransition = false;

        this.targetFrictionScroll = 0;
        this.isFriction = false;
        this.frictionRatio = .6;
        this.FRICTION_HEIGHT = 10;
        this.FRICTION_HEIGHT_SP = 8;
        this.isForward = true;

        this.frictionRatio = .6;
        this.delta = 0;
        this.currentDelta = 0;
        this.touchStartY = 0;



        this.heroStartPositions = [
            {x: 0, y: 0},
        ];

        this.heroEndPositions = [
            {x: -160, y: -100},
        ];

        this.section1StartPositions = [
            {x: 160, y: 100},
            {x: 0, y: 0},
        ];

        this.section1EndPositions = [
            {x: 0, y: 0},
            {x: 160, y: -100},
        ];

        this.section2StartPositions = [
            {x: -160, y: 100},
        ];

        this.section2EndPositions = [
            {x: 0, y: 0},
        ];

        this.heroX = 0;
        this.heroY = 0;
        this.heroXEase = this.heroX;
        this.heroYEase = this.heroY;

        this.section1X = 0;
        this.section1Y = 0;
        this.section1XEase = this.section1X;
        this.section1YEase = this.section1Y;

        this.section2X = 0;
        this.section2Y = 0;
        this.section2XEase = this.section2X;
        this.section2YEase = this.section2Y;

        this.pointer = new THREE.Vector2();
    }

    setDom(){
        super.setDom();

        this.heroVideoContainer = document.querySelector('main.top .kv_video');
        this.heroVideo = document.querySelector('main.top .kv_video video');
        this.setHeroVideoSrc();

        this.pageBGDOM = document.querySelector('main.top .page_bg');

        this.heroDOM = document.querySelector('main.top .hero');
        this.heroMaskTargetDOM = document.querySelector('main.top .hero .mask_target');

        this.section1DOM = document.querySelector('main.top .section1');
        this.section1Path = document.querySelectorAll('main.top .section1 .copy path, main.top .section1 .copy_lower path');

        this.section2DOM = document.querySelector('main.top .section2');
        this.section2PathPC = document.querySelectorAll('main.top .section2 .copy.pc svg > path');
        this.section2LowerPathPC = document.querySelector('main.top .section2 .copy_lower.pc svg > path');
        this.section2PathPC_CharO = document.querySelector('main.top .section2 .copy.pc svg .char_o');
        this.section2PathSP = document.querySelectorAll('main.top .section2 .copy.sp svg > path');
        this.section2LowerPathSP = document.querySelector('main.top .section2 .copy_lower.sp svg > path');
        this.section2PathSP_CharO = document.querySelector('main.top .section2 .copy.sp svg .char_o');

        this.section3DOM = document.querySelector('main.top .section3');
        this.section4DOM = document.querySelector('main.top .section4');
        this.section4Items = document.querySelectorAll('main.top .section4 .links li a .tit .item');
        this.section4Subtits = document.querySelectorAll('main.top .section4 .links li a .sub_tit');

        this.section5DOM = document.querySelector('main.top .section5');
        this.entryBtnDOM = document.querySelector('main.top .entry_btn');
        this.footerDOM = document.querySelector('footer');
        this.pageListDOM = document.querySelector('main.top .page_list');
        this.rocksContainerDOM = document.querySelector('main.top .rocks_container');
        this.rocksDOMs = document.querySelectorAll('main.top .rocks_container .rock');
        this.rocksInnerDOMs = document.querySelectorAll('main.top .rocks_container .rock_inner');
    }

    initEvents(){
        super.initEvents();
        this.bindPointerMoveHandler = this.pointerMoveHandler.bind(this);
        document.addEventListener('mousemove', this.bindPointerMoveHandler);
    }

    pointerMoveHandler(event){
        let x = event.clientX;
        let y = event.clientY;

        this.pointer.x = x;
        this.pointer.y = y;
    }

    setTransitionDelay(){
        this.setHeroTransitionDelay();
        this.setSection1TransitionDelay();
        this.setSection2TransitionDelay();
        this.setSection4TransitionDelay();
    }

    setHeroTransitionDelay(){
/*
        for( let i = 0, len = this.heroH2ChunksPC.length; i < len; i++ ){
            let chunk = this.heroH2ChunksPC[i];
            let items = chunk.querySelectorAll('.item');
            for( let j = 0, len = items.length; j < len; j++ ){
                let item = items[j];
                item.style.transitionDelay = i * .11 + j * .025 + 's';
            }
        }

        for( let i = 0, len = this.heroH2ChunksSP.length; i < len; i++ ){
            let chunk = this.heroH2ChunksSP[i];
            let items = chunk.querySelectorAll('.item');
            for( let j = 0, len = items.length; j < len; j++ ){
                let item = items[j];
                item.style.transitionDelay = i * .11 + j * .025 + 's';
            }
        }
*/
    }

    setSection1TransitionDelay(){
        //NodeListからArrayに変換
/*        let section1Path = [];
        Array.prototype.forEach.call(this.section1Path, (node) => {
            section1Path.push(node);
        });

        const lastElement = section1Path.pop();
        section1Path.splice(9, 0, lastElement); //10番目に挿入

        let singleDelay = .04;
        let delayAll = singleDelay * section1Path.length;
        for( let i = 0, len = section1Path.length; i < len; i++ ){
            let path = section1Path[i];
            let delay = delayAll - (singleDelay * i);
            path.style.transitionDelay = delay + 's';
        }*/
    }

    setSection2TransitionDelay(){
/*        let singleDelay = .02;
        let delayAll = singleDelay * this.section2PathPC.length;
        for( let i = 0, len = this.section2PathPC.length; i < len; i++ ){
            let id = i;
            if(i >= 4) id = i + 1;
            let path = this.section2PathPC[i];
            let delay = delayAll - (singleDelay * id);
            path.style.transitionDelay = delay + 's';
        }

        this.section2PathPC_CharO.style.transitionDelay = '2.0s';
        this.section2LowerPathPC.style.transitionDelay = '1.22s';

        delayAll = singleDelay * this.section2PathSP.length;
        for( let i = 0, len = this.section2PathSP.length; i < len; i++ ){
            let id = i;
            if(i >= 4) id = i + 1;
            let path = this.section2PathSP[i];
            let delay = delayAll - (singleDelay * id);
            path.style.transitionDelay = delay + 's';
        }

        this.section2PathSP_CharO.style.transitionDelay = '2.0s';
        this.section2LowerPathSP.style.transitionDelay = '1.22s';*/
    }

    setSection4TransitionDelay(){
        let singleDelay = .04;
        let singleDelay2 = .4;
        for( let i = 0, len = this.section4Items.length; i < len; i++ ){
            let item = this.section4Items[i];
            let delay = singleDelay * i;
            item.style.transitionDelay = delay + 's';
        }

        for( let i = 0, len = this.section4Subtits.length; i < len; i++ ){
            let item = this.section4Subtits[i];
            let delay = singleDelay2 * i;
            item.style.transitionDelay = .35 + delay + 's';
        }
    }

    initSections(){
        gsap.set(this.section1DOM, {x: 0, y: 0, opacity: 0});
        gsap.set(this.section2DOM, {x: 0, y: 0, opacity: 0});
        gsap.set(this.section3DOM, {x: '100vw', y: 0});
        gsap.set(this.rocksDOMs, {y: '120vh'});
        this.updateActiveSectionClasses();
    }

    start(isLanding){
        let delay, delay2;
        if(isLanding){
            delay = .01;
            delay2 = 2.01;
        }else{
            delay = 1;
            delay2 = 3;
        }


        this.setTransitionDelay();
        this.enabled = true;
        this.mask2.render();
        this.mask3.render();
        this.mask4.render();

        this.bg.start();
        this.mask1.start(isLanding);
        this.enterframeThinOut();

        gsap.delayedCall(delay, ()=>{
            this.heroDOM.classList.add('show');
            this.heroVideo.play();
            this.pageBGDOM.classList.add('show');
        });

        document.documentElement.classList.add('lock');
        gsap.delayedCall(delay2, ()=>{
            this.resizeHandler();
            this.enabledScroll = true;
            document.documentElement.classList.remove('lock');
        });
    }

    transitSection(current, targetY){
        this.isInTransition = true;
        this.currentSection = current;
        this.updateActiveSectionClasses();
        this.pack.anchorScroll(targetY, this.transitionDuration, this.transitionEase, ()=>{
            window.scrollTo(0, targetY);
            this.isInTransition = false;
        });
    }

    updateActiveSectionClasses(){
        const activeSections = [
            this.heroDOM,
            this.section1DOM,
            this.section2DOM,
            this.section3DOM,
            this.section4DOM,
        ];

        activeSections.forEach((section, index) => {
            if(!section) return;
            section.classList.toggle('is-active', index === this.currentSection);
        });
    }

    setFriction(targetFrictionScroll, scrollY, isForward){
        let friction = (this.sw >= this.pack.BP) ? this.FRICTION_HEIGHT : this.FRICTION_HEIGHT_SP;
        let next = (isForward) ? friction : -friction;
        this.isForward = isForward;
        if(!this.isFriction){
            this.targetFrictionScroll = targetFrictionScroll;
            this.nextFrictionScroll = this.targetFrictionScroll + next;
            this.currentEaseFrictionScroll = scrollY;
            this.isFriction = true;
        }
    }

    resetFriction(){
        this.isFriction = false;
        this.currentDelta = 0;
        this.currentEaseFrictionScroll = this.targetFrictionScroll;
    }

    backToHero(){
        let dr = this.transitionDuration;

        this.bg.backToHero();

        this.heroDOM.classList.remove('hide');
        if(this.entryBtnDOM){
            this.entryBtnDOM.classList.remove('small');
        }
        if(this.rocksContainerDOM) this.rocksContainerDOM.classList.remove('scattering', 'section2');
        gsap.killTweensOf(this.rocksDOMs);
        gsap.to(this.rocksDOMs, {duration: 0.6, x: 0, y: '120vh', opacity: 1, ease: 'quart.in'});
        this.heroMaskTargetDOM.classList.remove('shrink');
        this.mask1.setCanvasPosition();
        this.heroVideoContainer.classList.remove('hide');

        gsap.to(this.section1DOM, {duration: 0.2, opacity: 0, ease: 'power2.in'});
        if(this.transitionTween) this.transitionTween.kill();
    }

    startSection1(){
        let dr = this.transitionDuration;

        this.bg.startSection1();
        this.heroVideoContainer.classList.add('hide');
        this.heroMaskTargetDOM.classList.add('shrink');

        const isFirstVisit = !this.section1DOM.classList.contains('show');

        if(isFirstVisit){
            this.section1DOM.classList.add('show');
            gsap.set(this.section1DOM, {opacity: 1});
            gsap.delayedCall(2, ()=>{
                this.section1DOM.classList.remove('delay');
            });
        } else {
            gsap.delayedCall(this.transitionDuration, ()=>{
                this.section1DOM.classList.add('show');
            });
        }

        this.heroDOM.classList.add('hide');
        if(this.entryBtnDOM){
            this.entryBtnDOM.classList.add('fading');
            gsap.delayedCall(0.1, () => {
                this.entryBtnDOM.classList.remove('fading');
                this.entryBtnDOM.classList.add('small');
            });
        }
        this.startRocksAnimation();
        if(this.transitionTween) this.transitionTween.kill();
        if(!isFirstVisit){
            this.transitionTween = gsap.to(this.section1DOM, dr, {delay:.1, opacity: 1, ease: 'power2.out'});
        }

        // gsap.to(this.heroDOM, {duration: 2, motionPath:{path:[{x:'-160rem', y:'-50rem'}, {x:'-160rem', y:'-100rem'}]}, ease: 'quart.inOut'});
        // gsap.to(this.section1DOM, {duration: 2, motionPath:{path:[{x:'80rem', y:'100rem'}, {x:'0', y:'0'}]}, ease: 'quart.inOut'});
    }

    startRocksAnimation(){
        gsap.killTweensOf(this.rocksDOMs);
        if(this.rocksContainerDOM) this.rocksContainerDOM.classList.remove('scattering', 'section2');
        gsap.set(this.rocksDOMs, {x: 0, y: '120vh', opacity: 1});

        // blur rocks (index 0-4): slower, easeOut
        const blurConfigs = [
            {delay: 0.00, duration: 1.8},
            {delay: 0.05, duration: 1.7},
            {delay: 0.11, duration: 1.6},
            {delay: 0.01, duration: 1.9},
            {delay: 0.08, duration: 1.7},
        ];
        // sharp rocks (index 5-13): snappier
        const sharpConfigs = [
            {delay: 0.00, duration: 1.4},
            {delay: 0.06, duration: 1.6},
            {delay: 0.12, duration: 1.1},
            {delay: 0.04, duration: 1.3},
            {delay: 0.18, duration: 1.0},
            {delay: 0.09, duration: 1.2},
            {delay: 0.02, duration: 1.5},
            {delay: 0.22, duration: 0.9},
            {delay: 0.07, duration: 1.3},
        ];

        blurConfigs.forEach((cfg, i) => {
            gsap.to(this.rocksDOMs[i], {duration: cfg.duration, y: 0, delay: cfg.delay, ease: 'cubic.out'});
        });
        sharpConfigs.forEach((cfg, i) => {
            gsap.to(this.rocksDOMs[i + 5], {duration: cfg.duration, y: 0, delay: cfg.delay, ease: 'quart.out'});
        });

    }

    floatRocksAnimation(){
        // blur rocks (0-4): ゆったり
        const blurFloat = [
            {y: -14, dur: 2.6, delay: 0.0},
            {y: -20, dur: 3.1, delay: 0.8},
            {y: -12, dur: 2.4, delay: 1.5},
            {y: -18, dur: 3.4, delay: 0.3},
            {y: -16, dur: 2.9, delay: 2.0},
        ];
        // sharp rocks (5-13): 多様なリズム
        const sharpFloat = [
            {y: -22, dur: 2.5, delay: 0.5},
            {y: -18, dur: 3.0, delay: 1.2},
            {y: -26, dur: 2.2, delay: 0.1},
            {y: -15, dur: 3.2, delay: 1.7},
            {y: -20, dur: 2.7, delay: 0.6},
            {y: -24, dur: 2.1, delay: 1.0},
            {y: -17, dur: 3.5, delay: 2.2},
            {y: -21, dur: 2.3, delay: 0.4},
            {y: -19, dur: 2.9, delay: 1.4},
        ];

        blurFloat.forEach((cfg, i) => {
            gsap.to(this.rocksInnerDOMs[i], {y: cfg.y, duration: cfg.dur, delay: cfg.delay, ease: 'sine.inOut', repeat: -1, yoyo: true});
        });
        sharpFloat.forEach((cfg, i) => {
            gsap.to(this.rocksInnerDOMs[i + 5], {y: cfg.y, duration: cfg.dur, delay: cfg.delay, ease: 'sine.inOut', repeat: -1, yoyo: true});
        });
    }

    backToSection1(){
        let dr = this.transitionDuration;

        this.bg.backToSection1();
        gsap.delayedCall(0.7, () => {
            this.heroMaskTargetDOM.classList.remove('hide');
            gsap.to(this.section1DOM, {duration: 0.4, opacity: 1, ease: 'power2.out'});
        });

        // scatter rocks to the right, then re-enter from left with section1 layout
        gsap.delayedCall(0.3, () => this.rocksContainerDOM.classList.add('scattering'));
        gsap.killTweensOf(this.rocksDOMs);
        gsap.to(this.rocksDOMs, {
            x: '110vw', opacity: 0, duration: 0.45,
            stagger: 0.015, ease: 'quart.in',
            onComplete: () => {
                this.rocksContainerDOM.classList.remove('scattering', 'section2');
                gsap.set(this.rocksDOMs, {x: '-110vw', y: 0, opacity: 1});
                const blurIn = [
                    {delay: 0.00, duration: 1.8},
                    {delay: 0.05, duration: 1.7},
                    {delay: 0.11, duration: 1.6},
                    {delay: 0.01, duration: 1.9},
                    {delay: 0.08, duration: 1.7},
                ];
                const sharpIn = [
                    {delay: 0.00, duration: 1.4},
                    {delay: 0.06, duration: 1.6},
                    {delay: 0.12, duration: 1.1},
                    {delay: 0.04, duration: 1.3},
                    {delay: 0.18, duration: 1.0},
                    {delay: 0.09, duration: 1.2},
                    {delay: 0.02, duration: 1.5},
                    {delay: 0.22, duration: 0.9},
                    {delay: 0.07, duration: 1.3},
                ];
                blurIn.forEach((cfg, i) => {
                    gsap.to(this.rocksDOMs[i], {x: 0, duration: cfg.duration, delay: cfg.delay, ease: 'cubic.out'});
                });
                sharpIn.forEach((cfg, i) => {
                    gsap.to(this.rocksDOMs[i + 5], {x: 0, duration: cfg.duration, delay: cfg.delay, ease: 'quart.out'});
                });
            }
        });

        if(this.transitionTween) this.transitionTween.kill();
        this.transitionTween = gsap.to(this.section2DOM, {duration: 0.2, opacity: 0, ease: 'power2.in'});
    }
    

    startSection2(){
        let dr = this.transitionDuration;
        this.bg.startSection2();

        this.heroMaskTargetDOM.classList.add('hide');

        const isFirstVisit2 = !this.section2DOM.classList.contains('show');

        if(isFirstVisit2) {
            this.section2DOM.classList.add('show');
            gsap.set(this.section2DOM, {opacity: 1});
            gsap.delayedCall(1, ()=>{
                this.mask2.start();
            });
            gsap.delayedCall(2, ()=>{
                this.section2DOM.classList.remove('delay');
            });
        } else {
            gsap.delayedCall(this.transitionDuration, ()=>{
                this.section2DOM.classList.add('show');
            });
        }

        // scatter rocks to the left, then re-enter from right with section2
        gsap.delayedCall(0.3, () => this.rocksContainerDOM.classList.add('scattering'));
        gsap.killTweensOf(this.rocksDOMs);
        gsap.to(this.rocksDOMs, {
            x: '-110vw', opacity: 0, duration: 0.45,
            stagger: 0.015, ease: 'quart.in',
            onComplete: () => {
                this.rocksContainerDOM.classList.remove('scattering');
                this.rocksContainerDOM.classList.add('section2');
                gsap.set(this.rocksDOMs, {x: '110vw', y: 0, opacity: 1});
                const blurIn = [
                    {delay: 0.00, duration: 1.8},
                    {delay: 0.05, duration: 1.7},
                    {delay: 0.11, duration: 1.6},
                    {delay: 0.01, duration: 1.9},
                    {delay: 0.08, duration: 1.7},
                ];
                const sharpIn = [
                    {delay: 0.00, duration: 1.4},
                    {delay: 0.06, duration: 1.6},
                    {delay: 0.12, duration: 1.1},
                    {delay: 0.04, duration: 1.3},
                    {delay: 0.18, duration: 1.0},
                    {delay: 0.09, duration: 1.2},
                    {delay: 0.02, duration: 1.5},
                    {delay: 0.22, duration: 0.9},
                    {delay: 0.07, duration: 1.3},
                ];
                blurIn.forEach((cfg, i) => {
                    gsap.to(this.rocksDOMs[i], {x: 0, duration: cfg.duration, delay: cfg.delay, ease: 'cubic.out'});
                });
                sharpIn.forEach((cfg, i) => {
                    gsap.to(this.rocksDOMs[i + 5], {x: 0, duration: cfg.duration, delay: cfg.delay, ease: 'quart.out'});
                });
            }
        });

        gsap.to(this.section1DOM, {duration: 0.2, opacity: 0, ease: 'power2.in'});
        if(this.transitionTween) this.transitionTween.kill();
        if(!isFirstVisit2) {
            this.transitionTween = gsap.to(this.section2DOM, {duration: 0.4, delay: 0.1, opacity: 1, ease: 'power2.out'});
        }
    }

    backToSection2(){
        let dr = this.transitionDuration;

        this.section3DOM.classList.remove('dim', 'hidden');

        // rocks enter from left with section2 layout
        gsap.killTweensOf(this.rocksDOMs);
        this.rocksContainerDOM.classList.remove('scattering');
        this.rocksContainerDOM.classList.add('section2');
        gsap.set(this.rocksDOMs, {x: '-110vw', y: 0, opacity: 1});
        const blurIn = [
            {delay: 0.00, duration: 1.8},
            {delay: 0.05, duration: 1.7},
            {delay: 0.11, duration: 1.6},
            {delay: 0.01, duration: 1.9},
            {delay: 0.08, duration: 1.7},
        ];
        const sharpIn = [
            {delay: 0.00, duration: 1.4},
            {delay: 0.06, duration: 1.6},
            {delay: 0.12, duration: 1.1},
            {delay: 0.04, duration: 1.3},
            {delay: 0.18, duration: 1.0},
            {delay: 0.09, duration: 1.2},
            {delay: 0.02, duration: 1.5},
            {delay: 0.22, duration: 0.9},
            {delay: 0.07, duration: 1.3},
        ];
        const rockDelay = 0.5;
        blurIn.forEach((cfg, i) => {
            gsap.to(this.rocksDOMs[i], {x: 0, duration: cfg.duration, delay: rockDelay + cfg.delay, ease: 'cubic.out'});
        });
        sharpIn.forEach((cfg, i) => {
            gsap.to(this.rocksDOMs[i + 5], {x: 0, duration: cfg.duration, delay: rockDelay + cfg.delay, ease: 'quart.out'});
        });

        if(this.transitionTween) this.transitionTween.kill();
        this.transitionTween = gsap.to(this.section3DOM, dr, {x: '100vw', y: 0, ease:this.transitionEase});
        gsap.killTweensOf(this.section2DOM);
        gsap.to(this.section2DOM, {duration: 0.4, delay: 0.4, opacity: 1, ease: 'power2.out'});
    }

    startSection3(){
        let dr = this.transitionDuration;


        if(!this.mask3.startedAnimation) this.mask3.start(true);

        // scatter rocks to the left (no re-entry in section3)
        gsap.delayedCall(0.3, () => this.rocksContainerDOM.classList.add('scattering'));
        gsap.killTweensOf(this.rocksDOMs);
        gsap.to(this.rocksDOMs, {
            x: '-110vw', opacity: 0, duration: 0.45,
            stagger: 0.015, ease: 'quart.in',
            onComplete: () => {
                this.rocksContainerDOM.classList.remove('scattering');
                gsap.set(this.rocksDOMs, {x: 0, y: '120vh', opacity: 1});
            }
        });

        if(this.transitionTween) this.transitionTween.kill();
        gsap.to(this.section2DOM, {duration: 0.2, opacity: 0, ease: 'power2.in'});
        this.transitionTween = gsap.to(this.section3DOM, dr, {delay:.1, x:'0', y:'0', ease:this.transitionEase, onComplete:()=>{
        }});
    }

    backToSection3(){
        let dr = this.transitionDuration;
        if(this.transitionTween) this.transitionTween.kill();
        this.transitionTween = gsap.to(this.section4DOM, dr, {x: 0, y: '100vh', ease:this.transitionEase});
        gsap.killTweensOf(this.section3DOM);
        gsap.to(this.section3DOM, dr, {x:'0', y:'0', ease:this.transitionEase});
    }

    startSection4(){
        let dr = this.transitionDuration;

        gsap.delayedCall(this.transitionDuration, () => {
            if(!this.section4DOM.classList.contains('show')) {
                this.section4DOM.classList.add('show');
                gsap.delayedCall(1, () => {
                    this.section4DOM.classList.add('no_delay');
                });
            }
        });

        if(this.transitionTween) this.transitionTween.kill();
        gsap.to(this.section3DOM, dr, {x:'0', y:'-100vh', ease:this.transitionEase});
        this.transitionTween = gsap.to(this.section4DOM, dr, {delay:.1, x:'0', y:'0', ease:this.transitionEase});
    }

    scrollHandler(){
        if(!this.enabled) return;
        if(!this.enabledScroll) return;
        if(this.isInTransition) return;

        let scrollY = this.pack.scrollY;

        if(this.currentSection === 0){
            if( scrollY > 0) {
                //move to section1
                this.setFriction(0, scrollY, true);
                if(scrollY > this.nextFrictionScroll){
                    this.isFriction = false;
                    this.transitSection(1, this.sh);
                    this.startSection1();
                }
            }
        }else if(this.currentSection === 1){
            if(scrollY < this.sh) {
                //back to hero
                this.setFriction(this.sh, scrollY, false);
                if(scrollY < this.nextFrictionScroll){
                    this.transitSection(0, 0);
                    this.backToHero();
                }
            }else if(scrollY > this.sh){
                //move to section2
                this.setFriction(this.heroDOM.clientHeight + this.section1DOM.clientHeight - this.sh, scrollY, true);
                if(scrollY > this.nextFrictionScroll){
                    this.isFriction = false;
                    this.transitSection(2, this.sh * 2);
                    this.startSection2();
                }
            }
        }else if(this.currentSection === 2){
            if(scrollY < this.sh * 2) {
                //back to section1
                this.setFriction(this.heroDOM.clientHeight + this.section1DOM.clientHeight, scrollY, false);
                if(scrollY < this.nextFrictionScroll){
                    this.isFriction = false;
                    this.transitSection(1, this.sh);
                    this.backToSection1();
                }
            }else if(scrollY > this.sh * 2){
                //move to section3
                this.setFriction(this.heroDOM.clientHeight + this.section1DOM.clientHeight + this.section2DOM.clientHeight - this.sh, scrollY, true);
                if(scrollY > this.nextFrictionScroll){
                    this.isFriction = false;
                    this.transitSection(3, this.sh * 3);
                    this.startSection3();
                }
            }
        }else if(this.currentSection === 3){
            if(scrollY < this.sh * 3){
                //back to section2
                this.setFriction(this.heroDOM.clientHeight + this.section1DOM.clientHeight + this.section2DOM.clientHeight, scrollY, false);
                if(scrollY < this.nextFrictionScroll){
                    this.isFriction = false;
                    this.transitSection(2, this.sh * 2);
                    this.backToSection2();
                }
            }else if(scrollY > this.sh * 3){
                //section3 stays fixed, section4 slides over from below
                if(this.isFriction) this.resetFriction();
                let overshoot = scrollY - this.sh * 3;

                // section4 top above viewport midpoint: section3 dim
                if(scrollY > this.sh * 4 - this.shh){
                    this.section3DOM.classList.add('dim');
                }else{
                    this.section3DOM.classList.remove('dim', 'hidden');
                }

                // section4 bottom above viewport midpoint: section3 hidden
                if(scrollY > this.sh * 4 + this.section4DOM.offsetHeight - this.shh){
                    this.section3DOM.classList.add('hidden');
                }else{
                    this.section3DOM.classList.remove('hidden');
                }

                if(!this.section4DOM.classList.contains('show') && overshoot > this.sh * 0.3){
                    this.section4DOM.classList.add('show');
                    gsap.delayedCall(1, () => {
                        this.section4DOM.classList.add('no_delay');
                    });
                }

                if(scrollY >= this.sh * 4){
                    this.currentSection = 4;
                }
            }
        }else if(this.currentSection === 4){
            if(scrollY < this.sh * 4){
                //scrolled back into section3 exit territory
                this.currentSection = 3;
            }else{
                // section4 bottom above viewport midpoint: section3 hidden
                if(scrollY > this.sh * 4 + this.section4DOM.offsetHeight - this.shh){
                    this.section3DOM.classList.add('hidden');
                }else{
                    this.section3DOM.classList.remove('hidden');
                }
            }
        }

        this.bg.scrollHandler();
        this.checkEntryBtnOverlap();

        if(this.pageListDOM && !this.pageListDOM.classList.contains('show')){
            if(this.pageListDOM.getBoundingClientRect().top < this.sh * 0.85){
                this.pageListDOM.classList.add('show');
            }
        }

        const section5Offset = this.sw >= this.pack.BP ? 0 : this.sh * 1.5;
        if(scrollY > this.sh * 4 + this.section4DOM.offsetHeight + section5Offset){
            //show section5
            if(!this.mask4.startedAnimation) {
                this.mask4.start();
                this.section5DOM.classList.add('show');
            }
        }
    }


    checkEntryBtnOverlap(){
        if(!this.entryBtnDOM || !this.footerDOM) return;
        const btnRect = this.entryBtnDOM.getBoundingClientRect();
        const footerRect = this.footerDOM.getBoundingClientRect();
        const overlaps = btnRect.bottom > footerRect.top;
        this.entryBtnDOM.classList.toggle('fade_out', overlaps);
    }

    enterframe(){
        if(!this.enabled) return;
        this.bg.enterframe();
    }

    enterframeThinOut(){
        if(!this.enabled) return;
        // let ease = 1 / 3;

        // this.heroXEase += (this.heroX - this.heroXEase) * ease;
        // this.heroYEase += (this.heroY - this.heroYEase) * ease;
        // this.heroDOM.style.transform = `translate3d(${this.heroXEase}rem, ${this.heroYEase}rem, 0)`;
        // this.heroDOM.style.transform = `translate3d(${this.heroX}rem, ${this.heroY}rem, 0)`;

        /*

                this.section1XEase += (this.section1X - this.section1XEase) * ease2;
                this.section1YEase += (this.section1Y - this.section1YEase) * ease2;
                this.section1.style.transform = `translate3d(${this.section1XEase}rem, ${this.section1YEase}rem, 0)`;

                this.section2XEase += (this.section2X - this.section2XEase) * ease2;
                this.section2YEase += (this.section2Y - this.section2YEase) * ease2;
                this.section2.style.transform = `translate3d(${this.section2XEase}rem, ${this.section2YEase}rem, 0)`;

                // this.section1.style.transform = `translate3d(${secX}rem, ${secY}rem, 0)`;
                // this.section2.style.transform = `translate3d(${secX}rem, ${secY}rem, 0)`;*/



        this.bg.enterframeThinOut();
        this.mask1.enterframeThinOut();
        this.mask2.enterframeThinOut();
        this.mask3.enterframeThinOut();
        this.mask4.enterframeThinOut();


        if(this.isFriction){
            this.currentDelta += (this.delta - this.currentDelta) * .3;
            this.delta *= this.frictionRatio;
            let current = this.targetFrictionScroll + this.currentDelta;
            this.currentEaseFrictionScroll += (current - this.currentEaseFrictionScroll) * .3;
            window.scrollTo(0, this.currentEaseFrictionScroll);

            let dif = Math.abs(this.currentEaseFrictionScroll - this.targetFrictionScroll);

            if(dif < .5) {
                this.resetFriction();
                window.scrollTo(0, this.targetFrictionScroll);
            }
        }
    }

    setHeroVideoSrc(){
        if(!this.heroVideo) return;
        if(window.innerWidth >= this.pack.BP) return;
        const spSrc = this.heroVideo.dataset.srcSp;
        if(!spSrc) return;
        if(this.heroVideo.getAttribute('src') === spSrc) return;
        this.heroVideo.src = spSrc;
        this.heroVideo.load();
    }

    executeResize() {
        super.executeResize();
        this.shhh = this.shh >> 2;
        this.sectionHero12ScrollableHeight = this.heroDOM.offsetHeight + this.section1DOM.offsetHeight + this.section2DOM.offsetHeight;
        this.sectionHero12ScrollableSingleHeight = this.sectionHero12ScrollableHeight / 3;
        this.setHeroVideoSrc();
    }
}
